import React from 'react';

const BlueTick = (props: object) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 50C11.2152 50 0 38.7839 0 24.9996C0 11.2154 11.2144 0 25 0C38.7856 0 50 11.2146 50 24.9996C50 38.7839 38.7848 50 25 50Z"
        fill="#006AF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1298 34.1656C20.7579 34.1656 20.3847 34.0259 20.1002 33.7472L14.611 28.3695C13.2539 27.0401 15.316 25.0256 16.6694 26.3529L21.129 30.7226L33.3314 18.7669C34.6884 17.4374 36.7447 19.4583 35.3905 20.7842L22.1586 33.7472C21.8749 34.0259 21.5016 34.1656 21.1305 34.1656H21.1298Z"
        fill="white"
      />
    </svg>
  );
};

export default BlueTick;
